export default __webpack_public_path__ + "static/media/player-goals.e1d22a09.svg";